import { Collection } from 'modules/core/lib/mobx-rest'

import PermissionAccessGroup from 'modules/permissions/store/models/PermissionAccessGroup'

class PermissionAccessGroups extends Collection<PermissionAccessGroup> {
  get cacheKey(): string {
    return 'permissionAccessGroups'
  }

  model() {
    return PermissionAccessGroup
  }
}

const singleton: PermissionAccessGroups = new PermissionAccessGroups()

export default singleton
